export function generateCodeTfa(minCaracteres) {
  const minValor = Math.pow(10, minCaracteres - 1);
  const maxValor = Math.pow(10, minCaracteres) - 1;

  const numeroAleatorio = Math.floor(Math.random() * (maxValor - minValor + 1)) + minValor;

  return numeroAleatorio.toString();
}
